export const dmsDe = {
  archive: {
    title: 'Dokumentenablage',
    subtitle: 'Zentrale Ablage für allgemeine Dokumente, Verträge, Unterlagen und Vorlagen.',
  },
  manager: {
    title: 'Dokumente & Dateien',
    description: 'Geschützt abgelegte Dateien mit Prüfsumme und nachvollziehbarer Historie.',
  },
  upload: {
    dropTitle: 'Dateien hier ablegen oder auswählen',
    dropHint: 'PDF, JPG, PNG, WebP, TXT, CSV, DOCX oder XLSX · maximal 50 MB je Datei',
    select: 'Dateien auswählen',
    categoryHint: 'Die gewählte Kategorie wird für alle Dateien dieses Uploads verwendet.',
    success_one: '{{count}} Datei wurde hochgeladen.',
    success_other: '{{count}} Dateien wurden hochgeladen.',
  },
  search: {
    label: 'Dokumente durchsuchen',
    placeholder: 'Name, Titel oder Schlagwort …',
  },
  fields: {
    title: 'Anzeigename',
    category: 'Kategorie',
    tags: 'Schlagwörter (kommagetrennt)',
    description: 'Beschreibung / Notiz',
  },
  portal: {
    label: 'Im Kundenportal freigeben',
    hint: 'Nur ausdrücklich freigegebene Dateien sind für Portalbenutzer dieses Kunden sichtbar.',
    visible: 'Im Portal sichtbar',
  },
  categories: {
    GENERAL_FILE: 'Allgemeine Datei',
    CONTRACT: 'Vertrag',
    CERTIFICATE: 'Zertifikat',
    DATASHEET: 'Datenblatt',
    INVOICE_RECEIPT: 'Rechnung / Beleg',
    CORRESPONDENCE: 'Korrespondenz',
    CUSTOMS_DECLARATION: 'Zollanmeldung',
    IMAGE: 'Bild',
  },
  actions: {
    preview: 'Vorschau',
    previewNamed: 'Vorschau für {{name}} öffnen',
    download: 'Herunterladen',
  },
  item: {
    uploaded: '{{date}} · {{user}}',
  },
  empty: {
    title: 'Noch keine Dateien abgelegt',
    description: 'Legen Sie die ersten Dokumente per Drag & Drop ab.',
    search: 'Keine Dokumente entsprechen der Suche.',
  },
  edit: {
    title: 'Dokument bearbeiten',
    success: 'Dokumentdaten wurden gespeichert.',
  },
  delete: {
    title: 'Dokument endgültig löschen?',
    description:
      '„{{name}}“ wird aus der Ablage und dem geschützten Speicher entfernt. Der Vorgang bleibt im GoBD-Audit-Protokoll erhalten.',
    success: 'Dokument wurde gelöscht.',
  },
  preview: {
    error: 'Die Vorschau konnte nicht geladen werden.',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    page: 'Seite',
    zoom: 'Zoom',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    rotateLeft: 'Nach links drehen',
    rotateRight: 'Nach rechts drehen',
    fullscreen: 'Vollbild',
    textTruncated: 'Die Textvorschau wurde für eine flüssige Darstellung gekürzt.',
    uploadedAt: 'Hochgeladen am {{date}}',
  },
  errors: {
    list: 'Die Dokumente konnten nicht geladen werden.',
    download: 'Der Download ist fehlgeschlagen.',
    entityMissing: 'Die zugehörige ERP-Entität fehlt.',
    size: '„{{name}}“ ist leer oder größer als 50 MB.',
    uploadFile: '„{{name}}“ konnte nicht hochgeladen werden.',
  },
  tabs: {
    partner: 'Dokumente & Verträge',
    product: 'Dateien & Datenblätter',
    documentDetails: 'Belegdaten',
    documentAttachments: 'Anhänge',
  },
  batch: {
    title: 'Chargendokumente',
    subtitle: '{{product}} · Charge {{batch}}',
    back: 'Zurück zum Artikel',
    filesTitle: 'Analysenzertifikate & Laborberichte',
    loadError: 'Die Charge konnte nicht geladen werden.',
  },
} as const;
